export const PolicyUrl = 'https://www.yoffix.com/privacy-policy'
export const TermsUrl = 'https://www.yoffix.com/terms-of-use'
export const CheckoutReturnUrl = 'https://checkout.paddle.com/checkout'

export const DefaultSalesEmail = 'sales@yoffix.com'

export const YoffixSlackUrl = 'https://api.slack.com/apps/A029Q40PEDT/install-on-team'

export const JwtTokenName = 'auth:token'
